import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 md:gap-8">
          {/* Brand */}
          <div className="lg:col-span-2">
            <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-semibold mb-4">
              YourPhilly<span className="text-amber-500">TitleGuy</span>
            </h2>
            <p className="text-slate-400 text-base leading-relaxed max-w-md mb-6">
              Helping agents, attorneys, lenders, investors, and commercial clients get deals to the closing table across Philadelphia and South Jersey.
            </p>
            <div className="flex items-center gap-2 text-slate-400">
              <MapPin className="w-4 h-4 text-amber-500" />
              <span className="text-sm">Serving PA, NJ, FL & NY</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <a
                  href="https://alegaltitle.com/#"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-slate-400 hover:text-amber-500 transition-colors text-sm"
                  data-testid="footer-link-about"
                >
                  About American Legal Abstract
                </a>
              </li>
              <li>
                <a
                  href="https://alegaltitle.com/#services"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-slate-400 hover:text-amber-500 transition-colors text-sm"
                  data-testid="footer-link-services"
                >
                  Services
                </a>
              </li>
              <li>
                <a
                  href="https://alegaltitle.com/#why-us"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-slate-400 hover:text-amber-500 transition-colors text-sm"
                  data-testid="footer-link-why-us"
                >
                  Why American Legal Abstract
                </a>
              </li>
              <li>
                <a
                  href="https://alegaltitle.com/#faq"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-slate-400 hover:text-amber-500 transition-colors text-sm"
                  data-testid="footer-link-faq"
                >
                  FAQ
                </a>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-slate-400 hover:text-amber-500 transition-colors text-sm"
                  data-testid="footer-link-contact"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Get In Touch</h3>
            <ul className="space-y-3">
              <li>
                <a
                  href="tel:+12154166104"
                  className="flex items-center gap-3 text-slate-400 hover:text-amber-500 transition-colors text-sm"
                  data-testid="footer-phone"
                >
                  <Phone className="w-4 h-4 text-amber-500" />
                  (215) 416-6104
                </a>
              </li>
              <li>
                <a
                  href="mailto:Terry@alegaltitle.com"
                  className="flex items-center gap-3 text-slate-400 hover:text-amber-500 transition-colors text-sm"
                  data-testid="footer-email"
                >
                  <Mail className="w-4 h-4 text-amber-500" />
                  Terry@alegaltitle.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-slate-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-500 text-sm">
              © {currentYear} YourPhillyTitleGuy. All rights reserved.
            </p>
            <p className="text-slate-500 text-sm">
              Vice President of Sales & Marketing at{' '}
              <span className="text-amber-500"><a href="https://www.alegaltitle.com" target="_blank" rel="noopener noreferrer" className="hover:underline">American Legal Abstract</a></span>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
